"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";

const RemoveDarkModeOnNonAtlas = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname.startsWith("/atlas")) {
      document.documentElement.classList.remove("dark");
    }
  }, [pathname]);

  return null;
};

export default RemoveDarkModeOnNonAtlas; 